import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
    prefix: 'tw-',
    extend: {
        classGroups: {
            'font-size': [{ text: ['caption', 'micro', 'micro-8'] }]
        }
    }
});

// Private `cn` helper for the @/components/ui primitive layer. Product code
// must not import clsx/tailwind-merge directly — the `wm/no-style-exports`
// rule enforces that. Keeping this file inside the ui barrel (which is the
// single sanctioned style-ownership boundary) lets primitives compose
// classnames without breaking the ADR.
export function cn (...inputs) {
    return twMerge(clsx(inputs));
}
